import {SidebarMenuMain} from './SidebarMenuMain'
import {useRoles} from '../../../../../hooks/userRoleContext'

const SidebarMenu = () => {
  const {isAuthenticating} = useRoles()

  return (
    <div
      className='app-sidebar-menu overflow-hidden flex-column-fluid'
      style={{
        marginTop: '12.5%',
        opacity: isAuthenticating ? 0 : 1,
        pointerEvents: isAuthenticating ? 'none' : 'auto',
        transition: 'opacity 120ms ease',
      }}
    >
      <div
        id='kt_app_sidebar_menu_wrapper'
        className='app-sidebar-wrapper hover-scroll-overlay-y my-5'
        data-kt-scroll='true'
        data-kt-scroll-activate='true'
        data-kt-scroll-height='auto'
        data-kt-scroll-dependencies='#kt_app_sidebar_logo, #kt_app_sidebar_footer'
        data-kt-scroll-wrappers='#kt_app_sidebar_menu'
        data-kt-scroll-offset='5px'
        data-kt-scroll-save-state='true'
      >
        <div
          className='menu menu-column menu-rounded menu-sub-indention px-3'
          id='#kt_app_sidebar_menu'
          data-kt-menu='true'
          data-kt-menu-expand='false'
        >
          <SidebarMenuMain />
        </div>
      </div>
    </div>
  )
}

export {SidebarMenu}
